<div
  class="archived"
  *ngIf="hasArchivedMessages && !showArchived && !showActiveTickets"
  (click)="showArchivedRooms()"
>
  <div class="archived-icon-text">
    <div class="archived-icon">
      <mat-icon class="material-icons-outlined">archive</mat-icon>
    </div>
    <div class="archived-text">Arquivadas</div>
  </div>
  <div class="archived-num-unread" *ngIf="numArchivedMessagesUnread > 0">
    <span>{{ numArchivedMessagesUnread }}</span>
  </div>
</div>
